import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { MessagingService } from 'src/app/core/services/messaging.service';


import { FornecedorService } from '../../fornecedor/fornecedor.service';
import { EventoFornecedor, EventoFornecedorResponse, Fornecedor } from '../../fornecedor/models/fornecedor';
import { EventoService } from '../evento.service';
import { FormaPagamento } from '../models/evento';

@Component({
  selector: 'app-evento-detalhe-fornecedor',
  templateUrl: './evento-detalhe-fornecedor.component.html',
  styleUrls: ['./evento-detalhe-fornecedor.component.scss']
})
export class EventoDetalheFornecedorComponent implements OnInit, OnDestroy {

  @Input() idEvento: number = 0;    

  public fornecedores: Fornecedor[] = [];
  public fornecedoresUpd: Fornecedor[] = [];
  public fornecedoresIns: Fornecedor[] = [];
  public eventoFornecedores: EventoFornecedorResponse[] = [];

  public idEventoFornecedor: number;
  public idFornecedor: number;
  public eventoFornecedor: EventoFornecedor;
  public selectedFornecedor: Fornecedor;  

  public formasPagamento: FormaPagamento[];
  public selectedFormasPagamento: FormaPagamento[];

  public submitted: boolean;
  public displayMsg: boolean = false;
  public displayDialog: boolean;
  public minDate: Date = new Date();
  public isDisableFornecedor: boolean = false;

  public nomeFornecedor: string = "testese";
  public date: Date = new Date();
  

  constructor(public fornecedorService: FornecedorService,
    private eventoService: EventoService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.getEventoFornecedores(this.idEvento);
    this.getFornecedores();
    this.getFornecedoresSemEvento(this.idEvento);     
    this.getFormaPagamento();    
  }

  ngOnDestroy(): void {
    
}



  getFornecedores() {

    this.fornecedorService.getFornecedores().subscribe(
      (res) => {
        if (res) {
          this.fornecedoresUpd = res;
        }
      },
      err => {
        console.log("EventoDetalheFornecedor - EventoFornecedor");
        console.log(err);
      }
    );
  }


  getFornecedoresSemEvento(idEvento: number) {

    this.fornecedorService.getFornecedoresSemEvento(idEvento).subscribe(
      (res) => {
        if (res) {
          this.fornecedoresIns = res;
        }
      },
      err => {
        console.log("EventoDetalheFornecedor - EventoFornecedor");
        console.log(err);
      }
    );
  }

  getEventoFornecedores(idEvento: number) {

    this.fornecedorService.getEventoFornecedores(idEvento).subscribe(
      (res) => {
        if (res) {
          this.eventoFornecedores = res;
        }
      },
      err => {
        console.log("EventoDetalheFornecedor - EventoFornecedor");
        console.log(err);
      }
    );
  }

  getFornecedor(idfornecedor) {

    this.fornecedorService.getFornecedor(idfornecedor).subscribe(
      (res) => {
        if (res) {          
          this.eventoFornecedor = res; 
          if(!this.eventoFornecedor.vlFreteKm)     this.eventoFornecedor.vlFreteKm=0;   
          if(!this.eventoFornecedor.vlChapaTon)     this.eventoFornecedor.vlChapaTon=0;   
        }
      },
      err => {
        console.log("fornecedorList - fornecedor");
        console.log(err);
      }
    );
  }

  getFormaPagamento() {

    this.eventoService.getFormasPagamentoEvento().subscribe(
      (res) => {
        if (res) {
          this.formasPagamento = res;         
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - Formas Pagamento");
        console.log(err);
      }
    );
  } 

  getSelectedFornecedor(idFornecedor: number) {    
    return this.fornecedores.find(x => x.idFornecedor === idFornecedor);    
  }

  getSelectedFormasPagamento(idEventoFornecedor: number) {
    this.eventoService.getFormasPagamentoEventoForcendor(idEventoFornecedor).subscribe(
      (res) => {
        if (res) {
          this.selectedFormasPagamento = res;
        }
      },
      err => {
        console.log("EventoPedidoDetalhe - Formas Pagamento - Fornecedor");
        console.log(err);
      }
    );
  }

  SetFornecedor(idFornecedor: number)
  {
    this.eventoFornecedor.idFornecedor = idFornecedor;        
  }


  addFornecedor() {
    this.fornecedores = this.fornecedoresIns;
    this.eventoFornecedor = {};
    if(!this.eventoFornecedor.vlFreteKm)     this.eventoFornecedor.vlFreteKm=0;   
          if(!this.eventoFornecedor.vlChapaTon)     this.eventoFornecedor.vlChapaTon=0; 
    this.isDisableFornecedor = false;
    this.submitted = false;
    this.displayDialog = true;
  }

  updFornecedor(eventoFornecedor: EventoFornecedor) {     
    this.fornecedores = this.fornecedoresUpd;
    this.isDisableFornecedor = true;    
    this.selectedFornecedor = this.getSelectedFornecedor(eventoFornecedor.idFornecedor);
    this.getSelectedFormasPagamento(eventoFornecedor.idEventoFornecedor);
    this.eventoFornecedor = { ...eventoFornecedor };    
    if(!this.eventoFornecedor.vlFreteKm)     this.eventoFornecedor.vlFreteKm=0;   
          if(!this.eventoFornecedor.vlChapaTon)     this.eventoFornecedor.vlChapaTon=0; 
    this.eventoFornecedor.dtLimite = new Date(this.eventoFornecedor.dtLimite);
    this.eventoFornecedor.dtLimitePrazo = new Date(this.eventoFornecedor.dtLimitePrazo);
    this.displayDialog = true;     
  }

  delEventoFornecedor(eventoFornecedor: EventoFornecedor) {
    this.confirmationService.confirm({
      message: 'Você tem certeza que deseja remover o vinculo do fornecedor selecionado?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.fornecedorService
          .delEventoFornecedor(eventoFornecedor.idEventoFornecedor)
          .subscribe(
            () => {
              this.getEventoFornecedores(this.idEvento);
              this.getFornecedoresSemEvento(this.idEvento);
              this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Vinculo do fornecedor removido com sucesso!', life: 3000 });
            },
            err => {
              console.log(err);
              this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Ocorreu um erro ao remover o fornecedor. '+err, life: 10000 });
            }
          );        
      }
    });
  }


  hideDialog() {
    this.displayDialog = false;
    this.submitted = false;
  }

  

  saveFornecedor() {

    if(this.eventoFornecedor.flFreteSigeve){
       this.eventoFornecedor.vlFreteKm=0;   
      //this.eventoFornecedor.vlChapaTon=0; 
    }

    if(this.eventoFornecedor.qtMaxParcelas<=1 ){
      this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'A quantidade máxima de parcelas deve ser maior do que 1;', life: 10000 });
           return
    }
    this.submitted = true;
    this.idEventoFornecedor = this.eventoFornecedor.idEventoFornecedor;    
    if (this.eventoFornecedor.idEventoFornecedor) {            
      this.fornecedorService
        .updEventoFornecedor(this.eventoFornecedor)
        .subscribe(
          () => {              
            this.getEventoFornecedores(this.idEvento);
            this.getFornecedoresSemEvento(this.idEvento);
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Fornecedor atualizado com sucesso!', life: 3000 });
            this.saveFornecedorFormaPagto(this.idEventoFornecedor);
          },
          err => {
            this.messageService.add({ severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações. Erro:'+err, life: 10000 });
            console.log(err);
          }
        );
      
    } else {    
      
      this.eventoFornecedor.idEvento = this.idEvento;
      this.fornecedorService
        .addEventoFornecedor(this.eventoFornecedor)
        .subscribe(
          (response) => {
            this.getEventoFornecedores(this.idEvento);
            this.getFornecedoresSemEvento(this.idEvento);
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Fornecedor cadastrado com sucesso!', life: 3000 });           
            this.idEventoFornecedor = Number(response);
            this.saveFornecedorFormaPagto(this.idEventoFornecedor);
          },
          err => {
            this.messageService.add({ severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações. Erro:'+err, life: 10000 });
            console.log(err)
            
          }
        );      
    }

    
    this.fornecedores = [...this.fornecedores];
    //this.saveFornecedorFormaPagto(this.idEventoFornecedor);
    this.displayDialog = false;
    this.eventoFornecedor = {};
  }

  saveFornecedorFormaPagto(idEventoFornecedor: number) {        
    if (this.selectedFormasPagamento) {
      this.eventoService
        .updFornecedorPagamento(this.selectedFormasPagamento, idEventoFornecedor)
        .subscribe(
          () => 
          {
            console.log(idEventoFornecedor);
              console.log(this.selectedFormasPagamento);
          },
          err => console.log(err)
        );
      
    }         
   this.selectedFormasPagamento = [];
 }

}

